/*
 *   Copyright (c) 2021 vlinder Labs Private Limited
 *   All rights reserved.
 *   This software is proprietary of Vlinder Labs Pvt. Ltd and can not be distributed / used for any purpose outside of Vlinder Labs Pvt. Ltd without explicit written consent from the copyright owner.
 */
//@ts-nocheck
import React, { Suspense, lazy } from "react";
import {
    BrowserRouter as Router,
    Switch,
    Route,
    Link,
    Redirect,
} from "react-router-dom";
import { TypeWriterLoaderVW } from "@vlinder-web/typewriter-loader-widget-react";
import {Root} from "../framework/BugsBunny/src/index";
// import { AuthService } from "../services";
import { useAuth } from "../services/auth-service/auth.provider";
import { VApplication } from "../application";
import { lazyWithRetry} from "./ComponentLoader";


// const { isAuthenticated } = useAuth();




// const LandingPage = lazy(() => import("../pages/Landing"));
// const LoginPage = lazy(() => import("../pages/Login"));
// const PrivacyPolicyScreen = lazy(() => import("../pages/PrivacyPolicy"));
// const TermsandConditionScreen = lazy(() => import("../pages/TermsAndCondition"));

const LandingPage = lazyWithRetry(() => import("../pages/Landing"));
const LoginPage = lazyWithRetry(() => import("../pages/Login"));
const PrivacyPolicyScreen = lazyWithRetry(() => import("../pages/PrivacyPolicy"));
const TermsandConditionScreen = lazyWithRetry(() => import("../pages/TermsAndCondition"));
const KYCScreen = lazyWithRetry(() => import("../pages/KYC"));

const SignUpPage = lazy(() => import("../pages/SignUp"));

const vapp = VApplication.getInstance();
const storageService = vapp.getSync("services.StorageModule");

const userType = storageService.get("userType", "session"); 
const sessionToken = storageService.get("accessToken", "session")?.value;
const localToken = storageService.get("accessToken", "session")?.value;
const userRole = storageService.get("userProfile", "session")?.value?.role?.name;
const isWalletRegistered = storageService.get("userProfile", "session")?.value?.brand?.isWalletRegistered;
// console.log('userProfile in routes', isWalletRegistered);

const RouterConfig = (props) => (
    <Switch>
        <PrivateRoute path="/dashboard" component={() => (<Root userType={userType?.value} userRole= {userRole} isWalletRegistered={isWalletRegistered} />)} />
        <PrivateRoute path="/kyc" component={KYCScreen}/>
        <Route path="/login" component={LoginPage} />
        <Route path="/privacy" component={PrivacyPolicyScreen} />
        <Route path="/creds/create-account" component={LoginPage} />
        <Route exact path="/signup" component={SignUpPage} />
        <Route path="/terms" component={TermsandConditionScreen} />
        <Route path="/" component={LandingPage} />
    </Switch>
);

const loginService = VApplication.getInstance().getSync(
    "services.AuthService"
) as AuthService;




const PrivateRoute = ({ component: Component, ...rest }) => (
    <Route
        {...rest}
        render={(props) =>
           
            loginService.isAuthenticated() ? (
                <Component {...props} />
            ) : (
                <Redirect
                    to={{
                        pathname: `/`,
                    }}
                />
            )
        }
    />
);

function RouteWithSubRoutes(route) {
    return (
        <Route
            path={route.path}
            render={(props) => (
                // pass the sub-routes down to keep nesting
                <route.component {...props} routes={route.routes} />
            )}
        />
    );
}

export const AppNavigator = (): JSX.Element => {
    return (
        <Router>
            <Suspense fallback={<TypeWriterLoaderVW loaderText={"SLING"} />}>
                <RouterConfig />
            </Suspense>
        </Router>
    );
};
